/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddPendingUserTeamDto } from '../models/AddPendingUserTeamDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UserTeamControllerService {
    /**
     * @param requestBody
     * @returns any Created
     * @throws ApiError
     */
    public static addPendingUserTeam(
        requestBody: AddPendingUserTeamDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/user-teams/add-pending',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
